module.exports = __webpack_public_path__ + "img/glogo22.a32e60d0.png";